import React, {Component} from 'react'
import styles from './SortListItem.css'
import PropTypes from "prop-types"
import {TypeSortListItem} from "../../constants/consts-prop-types"
import {Icon, SortBy} from "../../constants/consts-types"
import Svg from "../Svg/Svg"

class SortListItem extends Component {
  static propTypes = {
    data: TypeSortListItem.isRequired,
    isSelected: PropTypes.bool.isRequired,
    orderBy: PropTypes.string.isRequired,
    onSortChange: PropTypes.func.isRequired
  }

  render() {
    const {isSelected, orderBy, onSortChange} = this.props
    const {id, title} = this.props.data

    return (
      <span
        className={styles.SortListItem}
        aria-sort={orderBy === SortBy.ASC ? SortBy.ascending : SortBy.descending}
      >
        <input
          id={id}
          readOnly
          aria-label={title}
          type="checkbox"
          onClick={() => onSortChange(id)}
          className={styles.checkbox}
          checked={isSelected}
        />
        <span className={styles.label}>{title}</span>
        {isSelected &&
          <Svg id={Icon.ARROW_DOWN} className={orderBy === SortBy.ASC ? styles.arrowASC : styles.arrowDESC}/>
        }
      </span>
    )
  }
}

export default SortListItem



// WEBPACK FOOTER //
// ./src/components/SortListItem/SortListItem.js